import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertCircle } from "lucide-react";

interface ErrorFallbackProps {
  error: unknown;
  resetError: () => void;
  router?: any;
}

export function ErrorFallbackComponent({ error, resetError, router }: ErrorFallbackProps) {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    setIsOpen(true);
  }, [error]);

  const handleBackToStartpage = async () => {
    setIsOpen(false);

    // Try to use router navigation if available
    if (router) {
      try {
        await router.navigate({ to: "/" });
        resetError();
        return;
      } catch (err) {
        console.error("Router navigation failed:", err);
      }
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertCircle className="h-5 w-5" />
            Ein Fehler ist aufgetreten
          </DialogTitle>
          <DialogDescription>
            Ooops! Etwas ist schiefgelaufen. Wir wurden darüber informiert und werden uns
            schnellstmöglich um dieses Problem kümmern.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2">
          <Button onClick={handleBackToStartpage}>Zurück zur Startseite</Button>
          <Button onClick={handleReload}>Seite neu laden</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
